module.exports = __webpack_public_path__ + "static/img/shangbiao_03.7e955ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/shangbiao_03.png
// module id = qOyU
// module chunks = 0